export const BIOMETRIC_AR = {
  title: "سياسة البيانات الحيوية والموافقة",
  version: "2.0",
  updated: "2026-06-12",
  intro:
    "هذه سياسة منفصلة ومُلزمة توضّح كيف يعالج HELCOO بصمة الوجه، وهي «بيانات شخصية حسّاسة» وفق GDPR (المادة 9) و UK GDPR وأنظمة حماية البيانات في السعودية والإمارات، وقوانين البيانات البيومترية في الولايات المتحدة (مثل BIPA في إلينوي و CUBI في تكساس). لا يُفعّل التحقق بالوجه لأي موظف إلا بعد موافقته الصريحة. جهة الاتصال: support@helcoo.uk.",
  sections: [
    {
      h: "1. ما نجمعه بالضبط",
      p: [
        "صورة حية للوجه تُلتقط لحظة تسجيل الحضور أو الانصراف، مع إشارات كشف الحياة (Liveness) للتأكد من وجود شخص حقيقي أمام الكاميرا ومنع التحايل بالصور أو الفيديو أو الأقنعة.",
        "قالب رقمي مشتق من الوجه (Face Template) وهو تمثيل رياضي مشفَّر لا يمكن إعادة تحويله إلى صورة، ويُستخدم للمطابقة فقط.",
        "لا نجمع بصمة الإصبع ولا قزحية العين ولا بصمة الصوت ولا أي مقياس حيوي آخر.",
      ],
    },
    {
      h: "2. الغرض الوحيد",
      p: [
        "التحقق من أن من يسجّل الحضور هو الموظف نفسه، ومنع الاحتيال في الدوام. لا شيء غير ذلك.",
        "لا تُستخدم البيانات الحيوية للإعلانات أو التسويق أو التنميط أو تقييم الأداء أو التعرّف على الأشخاص في الأماكن العامة، ولا لتدريب أي نموذج ذكاء اصطناعي لنا أو لأي طرف ثالث، ولا تُبَع أو تُؤجَّر أو تُقايَض بأي شكل.",
      ],
    },
    {
      h: "3. الموافقة الصريحة وسحبها",
      p: [
        "قبل تسجيل أول صورة مرجعية، يُعرض على الموظف إشعار واضح داخل التطبيق ويجب أن يوافق فعلياً. الموافقة اختيارية ومنفصلة عن قبول الشروط العامة، ويُحفظ سجل بتاريخ الموافقة ونسختها.",
        "يمكن سحب الموافقة في أي وقت من إعدادات التطبيق أو بمراسلة support@helcoo.uk. عند السحب يُحذف قالب الوجه وكل الصور المرجعية فوراً، ويتوقف التحقق بالوجه، ويتحوّل الموظف إلى طريقة تسجيل بديلة يحدّدها صاحب العمل.",
        "سحب الموافقة لا يمحو سجلات الحضور السابقة لأنها سجلات عمل ومالية مطلوبة نظاماً، لكنه يمحو كل البيانات الحيوية.",
      ],
    },
    {
      h: "4. الأدوار والمسؤولية",
      p: [
        "صاحب العمل (الشركة المشتركة) هو «المتحكم بالبيانات» وهو المسؤول قانوناً عن إبلاغ موظفيه والحصول على موافقتهم وفق قانون بلده، وعن تحديد سياسة بديلة لمن لا يوافق دون تمييز أو عقوبة.",
        "HELCOO هو «المعالج» ولا يعالج البيانات إلا بتعليمات صاحب العمل ولأغراض تشغيل الخدمة، ولا يصل إليها أي من موظفينا إلا في حدود ضيقة ومسجَّلة للدعم الفني.",
      ],
    },
    {
      h: "5. الاحتفاظ والإتلاف",
      p: [
        "قالب الوجه يُحفظ طوال ارتباط الموظف بحساب فعّال ووجود موافقة سارية.",
        "يُتلَف فوراً في أي من الحالات: سحب الموافقة، حذف الموظف من النظام، حذف الحساب من داخل التطبيق، انتهاء اشتراك الشركة، أو مرور سنة على آخر استخدام للحساب — أيّها أسبق.",
        "الصور الحية الملتقطة عند كل عملية تحقق تُستخدم للمطابقة اللحظية ولا تُخزَّن إلا لمدة محدودة لأغراض التدقيق ومكافحة الاحتيال، ثم تُحذف تلقائياً.",
      ],
    },
    {
      h: "6. المعالجون والأمن",
      p: [
        "تُجرى المطابقة وكشف الحياة عبر Amazon Rekognition (AWS) بموجب اتفاقية معالجة بيانات، ولا يُسمح لـ AWS باستخدام هذه البيانات لأغراضها الخاصة.",
        "النقل مشفَّر عبر TLS، والتخزين مشفَّر، والوصول مقيَّد بالأدوار ومسجَّل في سجلات تدقيق غير قابلة للتعديل، وبيانات كل شركة معزولة عن غيرها.",
      ],
    },
    {
      h: "7. حقوقك وتقديم الشكاوى",
      p: [
        "لك الحق في الوصول إلى بياناتك الحيوية والحصول على نسخة منها وتصحيحها وحذفها والاعتراض على معالجتها وسحب موافقتك، دون أي رسوم ودون أثر على خدمتك.",
        "لطلب أي من ذلك: support@helcoo.uk — نستجيب خلال 30 يوماً. ولك أيضاً حق الشكوى إلى الجهة الرقابية المختصة في بلدك (مثل ICO في المملكة المتحدة).",
      ],
    },
  ],
};
